<template>
  <base-container>
    <el-table
      ref="shift"
      border
      stripe
      :data="list"
      :header-cell-style="getCellStyle"
      size="mini"
      highlight-current-row
    >
      <el-table-column
        align="center"
        header-align="center"
        prop="shiftId"
        label="班次"
        width="120px"
      >
        <template slot-scope="{ row }">
          <span v-text="row.shiftName"></span><br />
          <span>({{ row.shiftStart }}-{{ row.shiftEnd }})</span>
          <i
            v-if="!isView"
            class="el-icon-setting clickable color-primary"
            @click="emitEvent('setRule', row.shiftId)"
          >
            批量设置
          </i>
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        header-align="center"
        v-for="week in weeks"
        :prop="'week' + week.weekNo"
        :label="week.name"
        :key="week.weekNo"
      >
        <template slot-scope="{ row }">
          <div class="week-container" v-if="row['week' + week.weekNo].length">
            <el-tooltip
              v-for="(period, index) in row['week' + week.weekNo]"
              :key="index"
              effect="light"
              :content="
                period.clinicType ? clinicTypeMap[period.clinicType] : '不限'
              "
              placement="right"
            >
              <el-row
                style="border-bottom: 0.5px #1989fa solid"
                type="flex"
                justify="space-between"
              >
                <span>{{ period.startPoint }}-{{ period.endPoint }}</span>
                <span>
                  {{ period.totalCount }}
                </span>
              </el-row>
            </el-tooltip>

            <el-row type="flex" justify="space-between">
              <b>合计</b>
              <b>{{ summary(row["week" + week.weekNo]) }}</b>
            </el-row>
          </div>
          <span v-else>--</span>
          <transition name="el-zoom-in-bottom">
            <el-row v-if="!isView" class="op-menu">
              <el-col
                :span="12"
                class="menu-item"
                @click.native="emitEvent('setRule', row.shiftId, week.weekNo)"
              >
                <i class="el-icon-setting"></i>设置
              </el-col>
              <el-col
                :span="12"
                class="menu-item"
                @click.native="emitEvent('clearRule', row.shiftId, week.weekNo)"
              >
                <i class="el-icon-remove-outline"></i>清除
              </el-col>
            </el-row>
          </transition>
        </template>
      </el-table-column>
    </el-table>
  </base-container>
</template>

<script>
import Config from "@/config/constant";
export default {
  props: {
    data: {
      type: Array,
      default: () => {
        return [];
      },
    },
    isView: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    data() {
      this.list = this.data;
    },
  },
  data() {
    return {
      weeks: Config.weeks,
      clinicTypeMap: Config.clinicType,
      list: this.data,
    };
  },
  methods: {
    summary(periods) {
      let sum = 0;
      periods.forEach((c) => {
        sum += c.totalCount;
      });
      return sum;
    },
    getCellStyle({ row, column }) {
      let obj = { color: "white" };
      if (!column.property || column.property == "shiftId") {
        obj.backgroundColor = "#1989FA";
      } else {
        obj.backgroundColor = "#409EFF";
      }
      return obj;
    },
    emitEvent(eventCode, shiftId, weekNo) {
      this.$emit(eventCode, shiftId, weekNo);
    },
  },
};
</script>

<style lang="scss" scoped>
i.el-icon-question:hover {
  color: #1989fa;
  cursor: pointer;
}
table.el-table__body {
  tbody {
    td.el-table__cell:hover {
      div.op-menu {
        display: block;
      }
      div.cell {
        padding: 0 5px;
      }
    }
  }
}
.op-menu {
  position: absolute;
  display: none;
  z-index: 500;
  bottom: 0;
  left: 0;
  right: 0;
  .menu-item {
    line-height: 30px;
    height: 30px;
    text-align: center;
    cursor: pointer;
    color: white;
    background-color: black;
    opacity: 0.3;
  }
  .menu-item:hover {
    background-color: #1989fa;
    opacity: 1;
  }
}
</style>
